{
  "slug": "can-anxiety-lower-iq-scores",
  "title": "焦虑可以降低智商测试分数?",
  "description": "焦虑可以消耗注意力或工作记忆,但效果各不相同。",
  "category": "智商问题答案",
  "sections": [
    {
      "heading": "简短答复",
      "paragraphs": ["焦虑可以消耗注意力或工作记忆,但效果各不相同。"]
    },
    {
      "heading": "什么影响它",
      "paragraphs": [
        "测试质量、年龄、健康、语言、教育、动机、环境和目的都很重要。",
        "平均研究效果不能准确预测一个人。"
      ]
    },
    {
      "heading": "指导",
      "paragraphs": [
        "使用足够的睡眠,安静的条件,住宿,和一个合适的仪器。",
        "对于儿童、健康、残疾或高风险决策,请咨询合格的专业人士。"
      ]
    }
  ],
  "related": ["what-is-iq", "how-is-iq-measured", "can-iq-change-over-time"],
  "sources": [],
  "faqs": [],
  "summary": "焦虑可以消耗注意力或工作记忆,但影响各不相同。 18 七月 2026."
}
